import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_MODALITY_LOCAL_TRAINING: 'fetchModalityLocalTraining',
  ON_SELECT_LOCAL_TRAINING: 'onSelectLocalTraining',
  ON_SELECT_MODALITY: 'onSelectModality'
}

export const globalActions = getNamespacedBy('modalityLocalTraining', actionTypes)
